import Vue from 'vue';
import VueRouter from 'vue-router';
import main from '../components/main';
import loginMxComp from '../page/loginMxComp';
// import downloadInfo from '../components/downloadInfo';
// import resultMx from '../components/mx/resultMx';
// import resultRoleInfoMx from '../components/mx/resultRoleInfoMx';

// import prepareInfoBr from '../components/br/prepareInfoBr.vue';
// import loginBr from '../components/br/loginBr.vue';
// import loginBrWhatsapp from '../components/br/loginBrWhatsapp.vue';
// import newLandingPage from '../components/br/newLandingPage.vue';
// import productInfoBr from '../components/br/productInfoBr';
// import typeInfoBr from '../components/br/typeInfoBr.vue';
// import baseInfoBr from '../components/br/baseInfoBr.vue';
// import photoInfoBr from '../components/br/photoInfoBr.vue';
// import resultBr from '../components/br/resultBr.vue';
// import uploadBr from '../components/br/uploadBr.vue';
// import selectPhotoBr from '../components/br/selectPhotoBr.vue';
// import detailMultiUploadBr from '../components/br/detailMultiUploadBr.vue';
// import uploadPdfBr from '../components/br/uploadPdfBr.vue';
// import resultRoleInfoBr from '../components/br/resultRoleInfoBr';
// import declareBr from '../components/br/declareBr';
// import multiUploadBr from '../components/br/multiUploadBr.vue';
// import setColorBr from '../components/br/setColorBr.vue';

// import loginMx from '../components/mx/loginMx.vue';
// import typeInfoMx from '../components/mx/typeInfoMx.vue';
// import productInfoMx from '../components/mx/productInfoMx';
// import baseInfoMx from '../components/mx/baseInfoMx.vue';
// import photoInfoMx from '../components/mx/photoInfoMx.vue';
// import uploadMx from '../components/mx/uploadMx.vue';
// import bindTipMx from '../components/mx/bindTipMx.vue';
// import setColorMx from '../components/mx/setColorMx.vue';
// import linkUploadMx from '../components/mx/linkUploadMx.vue';
// import multiDeclareMx from '../components/mx/multiDeclareMx.vue';
// import multiUploadMx from '../components/mx/multiUploadMx.vue';
// import introduceMx from '../components/mx/introduceMx.vue';
// import selectPhotoMx from '../components/mx/selectPhotoMx.vue';
// import detailMultiUploadMx from '../components/mx/detailMultiUploadMx.vue';
// import uploadPdfMx from '../components/mx/uploadPdfMx.vue';
// import uploadNewMx from '../components/mx/uploadNewMx.vue';

// import declareMx from '../components/mx/declareMx.vue';
// import linkageUploadMx from '../components/mx/linkageUploadMx.vue';
// import uploadCutMx from '../components/mx/uploadCutMx.vue';

// import example from '../components/base/Example.vue';
// import city from '../components/base/singlepage-city.vue';
// AU
// import loginAu from '../components/au/loginAu.vue';
// import baseInfoAu from '../components/au/baseInfoAu.vue';
// import photoInfoAu from '../components/au/photoInfoAu.vue';
// import resultAu from '../components/au/resultAu.vue';
// import uploadAu from '../components/au/uploadAu.vue';
// import uploadCutAu from '../components/au/uploadCutAu.vue';
// import multiUploadAu from '../components/au/multiUploadAu.vue';
// import linkageUploadAu from '../components/au/linkageUploadAu.vue';
// import linkUploadAu from '../components/au/linkUploadAu.vue';
// import declareAu from '../components/au/declareAu.vue';
// import multiDeclareAu from '../components/au/multiDeclareAu.vue';
// import setColorAu from '../components/au/setColorAu.vue';
// import resultRoleInfoAu from '../components/au/resultRoleInfoAu.vue';
// import selectPhotoAu from '../components/au/selectPhotoAu.vue';
// import uploadPdfAu from '../components/au/uploadPdfAu.vue';

// import photoProgress from "../components/photoProgress";
// import uploadNew from '../page/upload-new';
// import detailMultiUpload from '../components/base/select-photo/detail-multi-upload';
// import multiDeclare from '../components/base/multi-declare';
// import uploadCut from '../components/base/upload-cut';
// import linkUpload from '../components/base/link-upload';
// import loginNew from '../page/login';
// import typeInfo from '../page/typeInfo';
// import productInfo from '../page/productInfo';
// import uploadSimple from '../page/upload-simple';
// const loginMxComp = () => import ('../page/loginMxComp');
// import workInfo from '../page/workInfo';

// 主流程页面
const loginNew = () => import ('../page/login');
const typeInfo = () => import ('../page/typeInfo');
const productInfo = () => import ('../page/productInfo');
const workInfo = () => import ('../page/workInfo');
const baseInfo = () => import ('../components/baseInfo');
const photoInfo = () => import ('../components/photoInfo');
const resultRoleInfo = () => import ('../components/resultRoleInfo');
// 上传类组件
const uploadNew = () => import ('../page/upload-new');
const detailMultiUpload = () => import ('../components/base/select-photo/detail-multi-upload');
const declare = () => import ('../components/base/declare');
const multiDeclare = () => import ('../components/base/multi-declare');
const upload = () => import ('../components/base/Upload');
const uploadCut = () => import ('../components/base/upload-cut');
const uploadPdf = () => import ('../components/base/upload-pdf');
const selectPhoto = () => import ('../components/base/select-photo/select-photo');
const multiUpload = () => import ('../components/base/multi-upload');
const linkageUpload = () => import ('../components/base/linkage-upload');
const linkUpload = () => import ('../components/base/link-upload');
const uploadSimple = () => import ('../page/upload-simple');
const setColor = () => import ('../components/base/set-color');


// fleet绑司机
const bindTipMx = () => import ('../components/mx/bindTipMx.vue');

// 应该不会再使用的router
const photoProgress = () => import ('../components/photoProgress');
const example = () => import ('../components/base/Example.vue');
const city = () => import ('../components/base/singlepage-city.vue');
const resultAu = () => import ('../components/au/resultAu.vue');
const resultBr = () => import ('../components/br/resultBr.vue');
const resultMx = () => import ('../components/mx/resultMx.vue');
const productInfoBr = () => import ('../components/br/productInfoBr');
const typeInfoBr = () => import ('../components/br/typeInfoBr.vue');
const loginBr = () => import ('../components/br/loginBr.vue');
const loginBrWhatsapp = () => import ('../components/br/loginBrWhatsapp.vue');
const prepareInfoBr = () => import ('../components/br/prepareInfoBr.vue');
const newLandingPage = () => import ('../components/br/newLandingPage.vue');
const downloadInfo = () => import ('../components/downloadInfo');
const loginMx = () => import ('../components/mx/loginMx.vue');
const typeInfoMx = () => import ('../components/mx/typeInfoMx.vue');
const productInfoMx = () => import ('../components/mx/productInfoMx');
const introduceMx = () => import ('../components/mx/introduceMx.vue');
const loginAu = () => import ('../components/au/loginAu.vue');


// const avatarNew = () => import ('@didi/avatar-headimg-audit/dist/index.mjs');
// const avatarNewBetter = () => import ('@didi/avatar-headimg-audit/dist/better-page-index.mjs');

import {avatarNew} from '@didi/avatar-headimg-audit/dist/index.mjs';
import {avatarNewBetter} from '@didi/avatar-headimg-audit/dist/better-page-index.mjs';

import '@didi/avatar-headimg-audit/dist/index.css';
import '@didi/avatar-headimg-audit/dist/better-page-index.css';

import '../../di-css/di-button.css'

Vue.use (VueRouter);
let routes = [
  {
    name: 'home',
    path: '/home',
    component: main,
    alias: '/',
  },
  {
    name: 'loginBr',
    path: '/loginBr',
    component: loginBr,
  },
  {
    name: 'prepareInfoBr',
    path: '/prepareInfoBr',
    component: prepareInfoBr,
  },
  {
    name: 'loginBrWhatsapp',
    path: '/loginBrWhatsapp',
    component: loginBrWhatsapp,
  },
  {
    name: 'newLandingPage',
    path: '/newLandingPage',
    component: newLandingPage
  },
  {
    name: 'productInfoBr',
    path: '/productInfoBr',
    component: productInfoBr,
  },
  {
    name: 'typeInfoBr',
    path: '/typeInfoBr',
    component: typeInfoBr,
  },
  // {
  //   name: 'baseInfoBr',
  //   path: '/baseInfoBr',
  //   component: baseInfoBr,
  // },
  // {
  //   name: 'photoInfoBr',
  //   path: '/photoInfoBr',
  //   component: photoInfoBr,
  // },
  {
    name: 'resultBr',
    path: '/resultBr',
    component: resultBr,
  },
  // {
  //   name: 'uploadBr',
  //   path: '/uploadBr',
  //   component: uploadBr,
  // },
  // {
  //   name: 'selectPhotoBr',
  //   path: '/selectPhotoBr',
  //   component: selectPhotoBr,
  // },
  // {
  //   name: 'detailMultiUploadBr',
  //   path: '/detailMultiUploadBr',
  //   component: detailMultiUploadBr,
  // },
  // {
  //   name: 'uploadPdfBr',
  //   path: '/uploadPdfBr',
  //   component: uploadPdfBr,
  // },
  // {
  //   name: 'declareBr',
  //   path: '/declareBr',
  //   component: declareBr,
  // },
  // {
  //   name: 'multiUploadBr',
  //   path: '/multiUploadBr',
  //   component: multiUploadBr,
  // },
  // {
  //   name: 'setColorBr',
  //   path: '/setColorBr',
  //   component: setColorBr,
  // },
  // {
  //   name: 'resultRoleInfoBr',
  //   path: '/resultRoleInfoBr',
  //   component: resultRoleInfoBr,
  // },
  {
    name: 'loginAu',
    path: '/loginAu',
    component: loginAu,
  },
  // {
  //   name: 'baseInfoAu',
  //   path: '/baseInfoAu',
  //   component: baseInfoAu,
  // },
  // {
  //   name: 'photoInfoAu',
  //   path: '/photoInfoAu',
  //   component: photoInfoAu,
  // },
  {
    name: 'resultAu',
    path: '/resultAu',
    component: resultAu,
  },
  // {
  //   name: 'uploadAu',
  //   path: '/uploadAu',
  //   component: uploadAu,
  // },
  // {
  //   name: 'uploadCutAu',
  //   path: '/uploadCutAu',
  //   component: uploadCutAu,
  // },
  // {
  //   name: 'multiUploadAu',
  //   path: '/multiUploadAu',
  //   component: multiUploadAu,
  // },
  // {
  //   name: 'linkageUploadAu',
  //   path: '/linkageUploadAu',
  //   component: linkageUploadAu,
  // },
  // {
  //   name: 'linkUploadAu',
  //   path: '/linkUploadAu',
  //   component: linkUploadAu,
  // },
  // {
  //   name: 'declareAu',
  //   path: '/declareAu',
  //   component: declareAu,
  // },
  // {
  //   name: 'multiDeclareAu',
  //   path: '/multiDeclareAu',
  //   component: multiDeclareAu,
  // },
  // {
  //   name: 'resultRoleInfoAu',
  //   path: '/resultRoleInfoAu',
  //   component: resultRoleInfoAu,
  // },
  // {
  //   name: 'selectPhotoAu',
  //   path: '/selectPhotoAu',
  //   component: selectPhotoAu,
  // },
  // {
  //   name: 'uploadPdfAu',
  //   path: '/uploadPdfAu',
  //   component: uploadPdfAu,
  // },
  // {
  //   name: 'multiUploadMx',
  //   path: '/multiUploadMx',
  //   component: multiUploadMx,
  // },
  // {
  //   name: 'setColorAu',
  //   path: '/setColorAu',
  //   component: setColorAu,
  // },
  {
    name: 'loginMx',
    path: '/loginMx',
    component: loginMx,
  },
  {
    name: 'bindTipMx',
    path: '/bindTipMx',
    component: bindTipMx,
  },
  {
    name: 'productInfoMx',
    path: '/productInfoMx',
    component: productInfoMx,
  },
  {
    name: 'typeInfoMx',
    path: '/typeInfoMx',
    component: typeInfoMx,
  },
  // {
  //   name: 'baseInfoMx',
  //   path: '/baseInfoMx',
  //   component: baseInfoMx,
  // },
  // {
  //   name: 'photoInfoMx',
  //   path: '/photoInfoMx',
  //   component: photoInfoMx,
  // },
  {
    name: 'upload',
    path: '/upload',
    component: upload,
  },
  {
    name: 'resultMx',
    path: '/resultMx',
    component: resultMx,
  },
  // {
  //   name: 'resultRoleInfoMx',
  //   path: '/resultRoleInfoMx',
  //   component: resultRoleInfoMx,
  // },
  // {
  //   name: 'setColorMx',
  //   path: '/setColorMx',
  //   component: setColorMx,
  // },
  // {
  //   name: 'linkUploadMx',
  //   path: '/linkUploadMx',
  //   component: linkUploadMx,
  // },
  // {
  //   name: 'multiDeclareMx',
  //   path: '/multiDeclareMx',
  //   component: multiDeclareMx,
  // },
  {
    name: 'introduceMx',
    path: '/introduceMx',
    component: introduceMx,
  },
  // {
  //   name: 'selectPhotoMx',
  //   path: '/selectPhotoMX',
  //   component: selectPhotoMx,
  // },
  // {
  //   name: 'detailMultiUploadMx',
  //   path: '/detailMultiUploadMx',
  //   component: detailMultiUploadMx,
  // },
  // {
  //   name: 'uploadPdfMx',
  //   path: '/uploadPdfMx',
  //   component: uploadPdfMx,
  // },
  // {
  //   name: 'declareMx',
  //   path: '/declareMx',
  //   component: declareMx,
  // },
  // {
  //   name: 'linkageUploadMx',
  //   path: '/linkageUploadMx',
  //   component: linkageUploadMx,
  // },
  // {
  //   name: 'uploadCutMx',
  //   path: '/uploadCutMx',
  //   component: uploadCutMx,
  // },
  {
    name: 'example',
    path: '/example',
    component: example,
  },
  {
    name: 'city',
    path: '/city',
    component: city,
  },
  {
    name: 'photoProgress',
    path: '/photoProgress',
    component: photoProgress,
  },
  {
    name: 'downloadInfo',
    path: '/downloadInfo',
    component: downloadInfo,
  },
  {
    name: 'uploadNew',
    path: '/uploadNew',
    component: uploadNew,
  },
  {
    name: 'detailMultiUpload',
    path: '/detailMultiUpload',
    component: detailMultiUpload,
  },
  {
    name: 'declare',
    path: '/declare',
    component: declare,
  },
  {
    name: 'multiDeclare',
    path: '/multiDeclare',
    component: multiDeclare,
  },
  {
    name: 'typeInfo',
    path: '/typeInfo',
    component: typeInfo,
  },
  {
    name: 'login',
    path: '/login',
    component: loginNew,
  },
  {
    name: 'productInfo',
    path: '/productInfo',
    component: productInfo,
  },
  {
    name: 'uploadSimple',
    path: '/uploadSimple',
    component: uploadSimple,
  },
  {
    name: 'uploadCut',
    path: '/uploadCut',
    component: uploadCut,
  },
  {
    name: 'uploadPdf',
    path: '/uploadPdf',
    component: uploadPdf,
  },
  {
    name: 'selectPhoto',
    path: '/selectPhoto',
    component: selectPhoto,
  },
  {
    name: 'multiUpload',
    path: '/multiUpload',
    component: multiUpload,
  },
  {
    name: 'linkUpload',
    path: '/linkUpload',
    component: linkUpload,
  },
  {
    name: 'linkageUpload',
    path: '/linkageUpload',
    component: linkageUpload,
  },
  {
    name: 'setColor',
    path: '/setColor',
    component: setColor,
  },
  {
    name: 'loginMxComp',
    path: '/loginMxComp',
    component: loginMxComp,
  },
  {
    name: 'workInfo',
    path: '/workInfo',
    component: workInfo,
  },
  {
    name: 'baseInfo',
    path: '/baseInfo',
    component: baseInfo,
  },
  {
    name: 'photoInfo',
    path: '/photoInfo',
    component: photoInfo,
  },
  {
    name: 'resultRoleInfo',
    path: '/resultRoleInfo',
    component: resultRoleInfo,
  },
  {
    name: 'avatarNew',
    path: '/avatarNew',
    component: avatarNew,
  },
  {
    name: 'avatarNewBetter',
    path: '/avatarNewBetter',
    component: avatarNewBetter,
  },
];
let router = new VueRouter ({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0};
  },
});
export default router;
